<script setup lang="ts">
import type { NovaDescriptionsProps } from './NovaDescriptions.types'

defineProps<NovaDescriptionsProps>()
</script>

<template>
  <div class="descriptions">
    <p
      v-for="(description, index) in descriptions"
      :key="index"
      v-dompurify-html="description"
    />
  </div>
</template>

<style lang="scss" scoped>
.descriptions {
  display: flex;
  flex-direction: column;
  gap: 4px;

  > p {
    display: flex;
    align-items: flex-start;
    gap: 4px;
    @include text-style($text-body-12-regular);
    color: $color-text-3;
    line-height: 18px;
    word-break: break-all;

    &:before {
      display: block;
      content: '•';
    }

    :deep(a) {
      color: $color-primary-blue;
    }
  }
}
</style>
